var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_281_708)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.172 20.1776V21.3736C12.172 22.3328 12.65 23.1608 13.4807 23.6404C13.8804 23.8711 14.3264 23.9998 14.7889 24C15.2518 24.0003 15.6977 23.8713 16.0977 23.6404L21.4159 20.5699C22.2467 20.0903 22.7246 19.2624 22.7246 18.3031V2.61741C22.7246 1.17408 21.5505 0 20.1072 0H8.3945C6.95113 0 5.77691 1.17398 5.77691 2.61741V5.92392C5.77691 6.39825 6.16203 6.78338 6.63636 6.78338C7.11083 6.78338 7.49563 6.3983 7.49563 5.92392V2.61741C7.49563 2.1218 7.89889 1.71853 8.3945 1.71853H18.6579L13.4807 4.70808C12.6503 5.18761 12.172 6.01542 12.172 6.97434V18.4589H8.3945C7.89894 18.4589 7.49563 18.0558 7.49563 17.5602V14.6616C7.49563 14.187 7.11106 13.8022 6.63636 13.8022C6.16184 13.8022 5.77691 14.187 5.77691 14.6616V17.5602C5.77691 19.0036 6.95113 20.1776 8.3945 20.1776H12.172ZM4.20875 10.948L5.1552 11.8945C5.49078 12.2301 5.49069 12.7741 5.1552 13.1097C4.99367 13.2713 4.77599 13.3612 4.54756 13.3612C4.31891 13.3612 4.10145 13.2716 3.93969 13.1097L1.52661 10.6962C1.19113 10.3607 1.19108 9.81694 1.52661 9.48141L3.93969 7.06828C4.27531 6.73266 4.81939 6.7328 5.15516 7.06823C5.49064 7.40348 5.49055 7.94775 5.15516 8.28309L4.20875 9.22931H10.5491C11.0239 9.22931 11.4083 9.61406 11.4083 10.0888C11.4083 10.5636 11.0238 10.9481 10.5491 10.9481H4.20875V10.948Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_281_708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutIcon);
export default __webpack_public_path__ + "static/media/SignOutIcon.762f32373fd32e04ea329d0347d725c0.svg";
export { ForwardRef as ReactComponent };